import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { useMemo } from "react";

import { RichTooltip } from "~/components/UI/RichTooltip";
import { formatCents } from "~/utils/formatPrice";

interface ISpreadCellProps {
  bestAsk: number | null;
  bestBid: number | null;
  lastTradePrice: number | null;
  spread: number | null;
}

export const SpreadCell: FC<ISpreadCellProps> = ({
  spread,
  bestAsk,
  bestBid,
  lastTradePrice,
}) => {
  const tooltipText = useMemo(
    () =>
      `Last Trade: ${formatCents(lastTradePrice)}\nBest Ask: ${formatCents(bestAsk)}\nBest Bid: ${formatCents(bestBid)}`,
    [lastTradePrice, bestAsk, bestBid]
  );

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        gap: 1
      }}>
      <RichTooltip title={tooltipText} actionText="">
        <InfoOutlinedIcon
          color="disabled"
          fontSize="small"
          sx={{ fontSize: "15px" }}
        />
      </RichTooltip>
      <Typography variant="caption">{formatCents(spread)}</Typography>
    </Stack>
  );
};
